<template>
  <h4>Jadwal Piket</h4>
  <div class="card shadow">
    <div class="card-header">
      <div class="col-md-10 col-lg-8 col-xl-6 mx-auto my-3">
        <div class="card shadow">
          <div class="card-header">
            <div class="row row-cols-auto justify-content-between">
              <div class="col-auto d-inline-flex">
                <h5 class="my-auto">Jadwal</h5>
              </div>
              <div class="col-auto ms-auto">
                <select class="form-select form-select-sm shadow-sm" v-model="semester">
                  <option disabled value="">-- Pilih Semester --</option>
                  <option v-for="s in listSemester" :key="s" :value="s">{{ s.nama }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row mb-1">
              <label class="col-sm-4 col-form-label col-form-label-sm">Jenis Piket</label>
              <div class="col-sm-8">
                <v-select v-model="piket" placeholder="Pilih Jenis Piket" label="nama" :options="listPiket">
                  <template #no-options>
                    Jenis Piket tidak ditemukan.
                  </template>
                </v-select>
              </div>
            </div>
            <div class="row mb-1">
              <label class="col-sm-4 col-form-label col-form-label-sm">Hari</label>
              <div class="col-sm-8">
                <v-select v-model="hari" placeholder="Pilih Hari" label="nama" :options="listHari">
                  <template #no-options>
                    Hari tidak ditemukan.
                  </template>
                </v-select>
              </div>
            </div>
            <div class="row mb-0">
              <label class="col-sm-4 col-form-label col-form-label-sm">Lokasi</label>
              <div class="col-sm-8">
                <v-select v-model="lokasi" placeholder="Pilih Lokasi" label="nama" :options="listLokasi">
                  <template #no-options>
                    Lokasi tidak ditemukan.
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="card-footer" v-if="piket || hari || lokasi">
            <div class="row row-cols-auto justify-content-between">
              <div class="col-auto d-inline-flex">
                <div class="form-check my-auto">
                  <input class="form-check-input" type="checkbox" v-model="tampilkanWaktu" id="waktu">
                  <label class="form-check-label" for="waktu">
                    Tamplkan Waktu
                  </label>
                </div>
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-sm btn-success shadow-sm" @click="unduhPDF">Unduh Jadwal</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body vl-parent" ref="table" v-if="piket || hari || lokasi">
      <h5 v-if="piket && hari && lokasi">Jadwal {{ piket.nama }} Hari {{ hari.nama }} di {{ lokasi.nama }}</h5>
      <h5 v-else-if="piket && hari">Jadwal {{ piket.nama }} Hari {{ hari.nama }}</h5>
      <h5 v-else-if="piket && lokasi">Jadwal {{ piket.nama }} di {{ lokasi.nama }}</h5>
      <h5 v-else-if="hari && lokasi">Jadwal Piket Hari {{ hari.nama }} di {{ lokasi.nama }}</h5>
      <h5 v-else-if="piket">Jadwal {{ piket.nama }}</h5>
      <h5 v-else-if="hari">Jadwal Piket Hari {{ hari.nama }}</h5>
      <h5 v-else>Jadwal Piket di {{ lokasi.nama }}</h5>
      <div class="table-responsive shadow" v-if="piket && hari && lokasi">
        <table class="table table-sm table-hover table-light table-bordered border-secondary mb-0 align-middle"
          id="tabelJadwal">
          <thead class="text-center">
            <tr>
              <th>Jam Ke</th>
              <th>Guru</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody v-if="dataJadwal.length">
            <tr v-for="d in dataJadwal" :key="d">
              <td v-if="tampilkanWaktu" class="text-center">
                <strong>{{ d.jam_awal + " - " + d.jam_akhir }}</strong><br />
                <em>({{ d.waktu_mulai + " - " + d.waktu_selesai }})</em>
              </td>
              <td v-else class="text-center">{{ d.jam_awal + " - " + d.jam_akhir }}</td>
              <td>{{ d.nama_guru }}</td>
              <td>{{ d.keterangan || '-' }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center fst-italic py-3" colspan="5">Data tidak ditemukan.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive shadow" v-else-if="piket && hari">
        <table class="table table-sm table-hover table-light table-bordered border-secondary mb-0 align-middle"
          id="tabelJadwal">
          <thead class="text-center">
            <tr>
              <th>Jam Ke</th>
              <th>Guru</th>
              <th>Lokasi</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody v-if="dataJadwal.length">
            <tr v-for="d in dataJadwal" :key="d">
              <td v-if="tampilkanWaktu" class="text-center">
                <strong>{{ d.jam_awal + " - " + d.jam_akhir }}</strong><br />
                <em>({{ d.waktu_mulai + " - " + d.waktu_selesai }})</em>
              </td>
              <td v-else class="text-center">{{ d.jam_awal + " - " + d.jam_akhir }}</td>
              <td>{{ d.nama_guru }}</td>
              <td class="text-center">{{ d.nama_lokasi }}</td>
              <td>{{ d.keterangan || '-' }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center fst-italic py-3" colspan="5">Data tidak ditemukan.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive shadow" v-else-if="piket && lokasi">
        <table class="table table-sm table-hover table-light table-bordered border-secondary mb-0 align-middle"
          id="tabelJadwal">
          <thead class="text-center">
            <tr>
              <th>Hari</th>
              <th>Jam Ke</th>
              <th>Guru</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody v-if="dataJadwal.length">
            <tr v-for="d in dataJadwal" :key="d">
              <td class="text-center">{{ d.nama_hari }}</td>
              <td v-if="tampilkanWaktu" class="text-center">
                <strong>{{ d.jam_awal + " - " + d.jam_akhir }}</strong><br />
                <em>({{ d.waktu_mulai + " - " + d.waktu_selesai }})</em>
              </td>
              <td v-else class="text-center">{{ d.jam_awal + " - " + d.jam_akhir }}</td>
              <td>{{ d.nama_guru }}</td>
              <td>{{ d.keterangan || '-' }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center fst-italic py-3" colspan="5">Data tidak ditemukan.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive shadow" v-else-if="hari && lokasi">
        <table class="table table-sm table-hover table-light table-bordered border-secondary mb-0 align-middle"
          id="tabelJadwal">
          <thead class="text-center">
            <tr>
              <th>Jam Ke</th>
              <th>Jenis Piket</th>
              <th>Guru</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody v-if="dataJadwal.length">
            <tr v-for="d in dataJadwal" :key="d">
              <td v-if="tampilkanWaktu" class="text-center">
                <strong>{{ d.jam_awal + " - " + d.jam_akhir }}</strong><br />
                <em>({{ d.waktu_mulai + " - " + d.waktu_selesai }})</em>
              </td>
              <td v-else class="text-center">{{ d.jam_awal + " - " + d.jam_akhir }}</td>
              <td>{{ d.nama_piket }}</td>
              <td>{{ d.nama_guru }}</td>
              <td>{{ d.keterangan || '-' }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center fst-italic py-3" colspan="5">Data tidak ditemukan.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive shadow" v-else-if="piket">
        <table class="table table-sm table-hover table-light table-bordered border-secondary mb-0 align-middle"
          id="tabelJadwal">
          <thead class="text-center">
            <tr>
              <th>Hari</th>
              <th>Jam Ke</th>
              <th>Guru</th>
              <th>Lokasi</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody v-if="dataJadwal.length">
            <tr v-for="d in dataJadwal" :key="d">
              <td class="text-center">{{ d.nama_hari }}</td>
              <td v-if="tampilkanWaktu" class="text-center">
                <strong>{{ d.jam_awal + " - " + d.jam_akhir }}</strong><br />
                <em>({{ d.waktu_mulai + " - " + d.waktu_selesai }})</em>
              </td>
              <td v-else class="text-center">{{ d.jam_awal + " - " + d.jam_akhir }}</td>
              <td>{{ d.nama_guru }}</td>
              <td class="text-center">{{ d.nama_lokasi }}</td>
              <td>{{ d.keterangan || '-' }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center fst-italic py-3" colspan="5">Data tidak ditemukan.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive shadow" v-else-if="hari">
        <table class="table table-sm table-hover table-light table-bordered border-secondary mb-0 align-middle"
          id="tabelJadwal">
          <thead class="text-center">
            <tr>
              <th>Jam Ke</th>
              <th>Jenis Piket</th>
              <th>Guru</th>
              <th>Lokasi</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody v-if="dataJadwal.length">
            <tr v-for="d in dataJadwal" :key="d">
              <td v-if="tampilkanWaktu" class="text-center">
                <strong>{{ d.jam_awal + " - " + d.jam_akhir }}</strong><br />
                <em>({{ d.waktu_mulai + " - " + d.waktu_selesai }})</em>
              </td>
              <td v-else class="text-center">{{ d.jam_awal + " - " + d.jam_akhir }}</td>
              <td>{{ d.nama_piket }}</td>
              <td>{{ d.nama_guru }}</td>
              <td class="text-center">{{ d.nama_lokasi }}</td>
              <td>{{ d.keterangan || '-' }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center fst-italic py-3" colspan="5">Data tidak ditemukan.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive shadow" v-else>
        <table class="table table-sm table-hover table-light table-bordered border-secondary mb-0 align-middle"
          id="tabelJadwal">
          <thead class="text-center">
            <tr>
              <th>Hari</th>
              <th>Jam Ke</th>
              <th>Jenis Piket</th>
              <th>Guru</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody v-if="dataJadwal.length">
            <tr v-for="d in dataJadwal" :key="d">
              <td class="text-center">{{ d.nama_hari }}</td>
              <td v-if="tampilkanWaktu" class="text-center">
                <strong>{{ d.jam_awal + " - " + d.jam_akhir }}</strong><br />
                <em>({{ d.waktu_mulai + " - " + d.waktu_selesai }})</em>
              </td>
              <td v-else class="text-center">{{ d.jam_awal + " - " + d.jam_akhir }}</td>
              <td>{{ d.nama_piket }}</td>
              <td>{{ d.nama_guru }}</td>
              <td>{{ d.keterangan || '-' }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center fst-italic py-3" colspan="5">Data tidak ditemukan.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <span v-if="dataJadwal.length" class="small text-muted fst-italic">
        Menampilkan {{ pageOffset + 1 }}-{{ pageOffset + dataJadwal.length }} dari total {{ count }} data
      </span>
      <div v-if="dataJadwal.length" class="row row-cols-auto justify-content-sm-between justify-content-center mt-2">
        <div class="row row-cols-auto">
          <label class="col-auto col-form-label-sm pe-1" for="numRows">Tampilkan:</label>
          <div class="col-auto ps-1">
            <select class="form-select form-select-sm shadow" v-model="pageLimit" id="numRows">
              <option v-for="l in arrayLimit" :key="l" :value="l">
                {{ l }} baris
              </option>
            </select>
          </div>
        </div>
        <div class="col-auto">
          <ul class="pagination pagination-sm shadow mb-0">
            <li class="page-item">
              <button class="page-link" :class="{ disabled: pageCurrent == 1 }"
                @click="pageCurrent > 1 ? pageCurrent-- : ''">&laquo;</button>
            </li>
            <li class="page-item" v-for="p in pageCount " :key="p">
              <button v-if="p == pageCurrent" class="page-link active fw-bold">{{ p }}</button>
              <button v-else-if="p == 1 || p == pageCount || Math.abs(p - pageCurrent) == 1" class="page-link"
                @click="pageCurrent = p">{{ p }}</button>
              <button v-else-if="(Math.abs(pageCurrent - 1) < 4 && Math.abs(p - 1) < 5) ||
                (Math.abs(pageCurrent - pageCount) < 4 && Math.abs(p - pageCount) < 5)" class="page-link"
                @click="pageCurrent = p">{{ p }}</button>
              <button
                v-else-if="(Math.abs(p - 1) == 5 || Math.abs(p - pageCount) == 5) && (Math.abs(p - pageCount) == 1 || Math.abs(p - 1) == 1)"
                class="page-link" @click="pageCurrent = p">{{ p }}</button>
              <button v-else-if="Math.abs(p - pageCurrent) == 2 ||
                (Math.abs(pageCurrent - 1) < 4 && Math.abs(p - 1) == 5) ||
                (Math.abs(pageCurrent - pageCount) < 4 && Math.abs(p - pageCount) == 5)" class="page-link px-1"
                @click="pageCurrent = p">...</button>
            </li>
            <li class="page-item">
              <button class="page-link" :class="{ disabled: pageCurrent == pageCount }"
                @click="pageCurrent < pageCount ? pageCurrent++ : ''">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebSocketService from './WebSocketService';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
export default {
  name: 'JadwalPiket',
  data() {
    return {
      dataListener: (d) => {
        if (d == 'piket' || d == 'statusPiket') {
          this.getListPiket();
        } else if (d == 'hari' || d == 'statusHari') {
          this.getListHari();
        } else if (d == 'lokasi' || d == 'statusLokasi') {
          this.getListLokasi();
        }
        if (this.piket || this.hari || this.lokasi) {
          if (this.pageCurrent == 1) {
            this.getDataJadwal();
          } else {
            this.pageCurrent = 1;
          }
        }
      },
      penjadwalanListener: (d) => {
        const data = JSON.parse(d);
        if (data.semester_id == this.semester.semester_id) {
          if (this.piket || this.hari || this.lokasi) {
            if (data.guru_id) {
              const cekGuru = this.dataJadwal.findIndex((d) => d.guru_id == data.guru_id);
              if (cekGuru >= 0) {
                if (this.pageCurrent == 1) {
                  this.getDataJadwal();
                } else {
                  this.pageCurrent = 1;
                }
              }
            } else if (data.piket_id) {
              const cekPiket = this.dataJadwal.findIndex((d) => d.piket_id == data.piket_id);
              if (this.piket.piket_id == data.piket_id ||
                this.piket.piket_id == data.old_piket_id ||
                this.piket.piket_id == data.new_piket_id ||
                cekPiket >= 0) {
                if (this.pageCurrent == 1) {
                  this.getDataJadwal();
                } else {
                  this.pageCurrent = 1;
                }
              }
            }
          }
        }
      },
      dataJadwal: [],
      listSemester: [],
      listPiket: [],
      listHari: [],
      listLokasi: [],
      semester: "",
      piket: "",
      hari: "",
      lokasi: "",
      tampilkanWaktu: false,
      arrayLimit: [10, 25, 50, 100, 250],
      count: 0,
      pageCurrent: 1,
      pageOffset: 0,
      pageLimit: 10,
      pageCount: 0,
    }
  },
  mounted() {
    WebSocketService.on("inserted-or-deleted-data", this.dataListener);
    WebSocketService.on("update-data", this.dataListener);
    WebSocketService.on("inserted-or-deleted-jadwal", this.penjadwalanListener);
    WebSocketService.on("update-jadwal", this.penjadwalanListener);
    this.pageLimit = this.batasBaris;
    this.semester = {
      tahun_ajaran_id: this.tpAktif.tahun_ajaran_id,
      ...this.semesterAktif
    };
    this.getListSemester();
  },
  beforeUnmount() {
    WebSocketService.off("inserted-or-deleted-data", this.dataListener);
    WebSocketService.off("update-data", this.dataListener);
    WebSocketService.off("inserted-or-deleted-jadwal", this.penjadwalanListener);
    WebSocketService.off("update-jadwal", this.penjadwalanListener);
  },
  computed: {
    tpAktif() {
      return this.$store.getters.getTp
    },
    semesterAktif() {
      return this.$store.getters.getSemester
    },
    batasBaris() {
      return this.$store.getters.getDefaultLimit
    },
  },
  watch: {
    semesterAktif() {
      this.semester = {
        tahun_ajaran_id: this.tpAktif.tahun_ajaran_id,
        ...this.semesterAktif
      };
    },
    semester() {
      this.getListPiket();
      this.getListHari();
      this.getListLokasi();
      if (this.hari || this.piket || this.lokasi) {
        if (this.pageCurrent == 1) {
          this.getDataJadwal();
        } else {
          this.pageCurrent = 1;
        }
      }
    },
    listPiket() {
      const cekPiket = this.listPiket.findIndex((d) => d.piket_id == this.piket.piket_id);
      if (cekPiket < 0) {
        this.piket = "";
      }
    },
    piket() {
      if (this.pageCurrent == 1) {
        this.getDataJadwal();
      } else {
        this.pageCurrent = 1;
      }
    },
    listHari() {
      const cekHari = this.listHari.findIndex((d) => d.hari_id == this.hari.hari_id);
      if (cekHari < 0) {
        this.hari = "";
      }
    },
    hari() {
      if (this.pageCurrent == 1) {
        this.getDataJadwal();
      } else {
        this.pageCurrent = 1;
      }
    },
    listLokasi() {
      const cekLokasi = this.listLokasi.findIndex((d) => d.lokasi_id == this.lokasi.lokasi_id);
      if (cekLokasi < 0) {
        this.lokasi = "";
      }
    },
    lokasi() {
      if (this.pageCurrent == 1) {
        this.getDataJadwal();
      } else {
        this.pageCurrent = 1;
      }
    },
    pageCurrent() {
      this.pageOffset = (this.pageCurrent - 1) * this.pageLimit;
      if(this.hari || this.lokasi) {
        this.getDataJadwal();
      }
    },
    pageLimit() {
      if (this.pageCurrent == 1) {
        this.getDataJadwal();
      } else {
        this.pageCurrent = 1;
      }
    },
  },
  methods: {
    async getListSemester() {
      const headers = {
        Authorization: localStorage.getItem('token')
      };
      try {
        const response = await this.axios.post('/penjadwalan/semester/list', {}, {
          headers: headers
        });
        if (response.data) {
          this.listSemester = response.data.semester;
        }
      }
      catch (err) {
        if (err.response) {
          if (err.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silahkan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$router.go();
            });
          } else {
            console.log(err);
          }
        } else {
          console.log(err)
        }
      }
    },
    async getListPiket() {
      const headers = {
        Authorization: localStorage.getItem('token')
      };
      try {
        const response = await this.axios.post('/piket/list', {}, {
          headers: headers
        });
        if (response.data) {
          this.listPiket = response.data.piket;
        }
      }
      catch (err) {
        if (err.response) {
          if (err.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silahkan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$router.go();
            });
          } else {
            console.log(err);
          }
        } else {
          console.log(err)
        }
      }
    },
    async getListHari() {
      const headers = {
        Authorization: localStorage.getItem('token')
      };
      try {
        const response = await this.axios.post('/hari/aktif', {}, {
          headers: headers
        });
        if (response.data) {
          this.listHari = response.data.hari;
        }
      }
      catch (err) {
        if (err.response) {
          if (err.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silahkan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$router.go();
            });
          } else {
            console.log(err);
          }
        } else {
          console.log(err)
        }
      }
    },
    async getListLokasi() {
      const headers = {
        Authorization: localStorage.getItem('token')
      };
      try {
        const response = await this.axios.post('/lokasi/list', {}, {
          headers: headers
        });
        if (response.data) {
          this.listLokasi = response.data.lokasi;
        }
      }
      catch (err) {
        if (err.response) {
          if (err.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silahkan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$router.go();
            });
          } else {
            console.log(err);
          }
        } else {
          console.log(err)
        }
      }
    },
    async getDataJadwal() {
      if (this.piket || this.hari || this.lokasi) {
        let memuat = this.$loading.show({
          container: this.$refs.table,
          loader: 'dots'
        });
        const headers = {
          Authorization: localStorage.getItem('token')
        };
        try {
          const response = await this.axios.post('/jadwal/piket', {
            semester_id: this.semester.semester_id,
            piket_id: this.piket ? this.piket.piket_id : null,
            hari_id: this.hari ? this.hari.hari_id : null,
            lokasi_id: this.lokasi ? this.lokasi.lokasi_id : null,
            limit: this.pageLimit,
            offset: this.pageOffset,
          }, {
            headers: headers
          });
          if (response.data) {
            const jadwalTemp = response.data.jadwal;
            for (const j of jadwalTemp) {
              if (j.waktu_mulai_khusus && j.waktu_selesai_khusus) {
                j.waktu_mulai = j.waktu_mulai_khusus.split(':').slice(0, 2).join(':');
                j.waktu_selesai = j.waktu_selesai_khusus.split(':').slice(0, 2).join(':');
              } else {
                j.waktu_mulai = j.waktu_mulai.split(':').slice(0, 2).join(':');
                j.waktu_selesai = j.waktu_selesai.split(':').slice(0, 2).join(':');
              }
            }
            this.dataJadwal = jadwalTemp;
            this.count = response.data.count;
            this.pageCount = Math.ceil(this.count / this.pageLimit) || 0;
          }
        }
        catch (err) {
          if (err.response) {
            if (err.response.status == 401) {
              this.$swal({
                title: 'Gagal',
                text: 'Sesi berakhir. Silahkan login ulang.',
                icon: 'error',
                confirmButtonText: 'Baik'
              }).then(() => {
                this.$router.go();
              });
            } else {
              console.log(err);
            }
          } else {
            console.log(err)
          }
        }
        setTimeout(() => {
          memuat.hide();
        }, 250);
      }
    },
    unduhPDF() {
      if (this.dataJadwal.length) {
        const doc = new jsPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'a4',
        });

        const judul = this.piket && this.hari && this.lokasi ? `Jadwal ${this.piket.nama} Hari ${this.hari.nama} di ${this.lokasi.nama}` :
          this.piket && this.hari ? `Jadwal ${this.piket.nama} Hari ${this.hari.nama}` :
            this.piket && this.lokasi ? `Jadwal ${this.piket.nama} di ${this.lokasi.nama}` :
              this.hari && this.lokasi ? `Jadwal Piket Hari ${this.hari.nama} di ${this.lokasi.nama}` :
                this.piket ? `Jadwal ${this.piket.nama}` :
                  this.hari ? `Jadwal Piket Hari ${this.hari.nama}` :
                    `Jadwal Piket di ${this.lokasi.nama}`;

        doc.setFontSize(14);
        doc.text(judul, 20, 15);

        const columnStyles = this.piket && this.hari && this.lokasi ? {
          0: { halign: 'center', cellWidth: 'wrap', fontSize: this.tampilkanWaktu ? 8 : 10 },
        } :
          this.piket && this.hari ? {
            0: { halign: 'center', cellWidth: 'wrap', fontSize: this.tampilkanWaktu ? 8 : 10 },
            2: { halign: 'center', cellWidth: 'wrap' },
          } :
            this.piket && this.lokasi ? {
              0: { halign: 'center', cellWidth: 'wrap' },
              1: { halign: 'center', cellWidth: 'wrap', fontSize: this.tampilkanWaktu ? 8 : 10 },
            } :
              this.hari && this.lokasi ? {
                0: { halign: 'center', cellWidth: 'wrap', fontSize: this.tampilkanWaktu ? 8 : 10 },
              } :
                this.piket ? {
                  0: { halign: 'center', cellWidth: 'wrap' },
                  1: { halign: 'center', cellWidth: 'wrap', fontSize: this.tampilkanWaktu ? 8 : 10 },
                  3: { halign: 'center', cellWidth: 'wrap' },
                } :
                  this.hari ? {
                    0: { halign: 'center', cellWidth: 'wrap', fontSize: this.tampilkanWaktu ? 8 : 10 },
                    3: { halign: 'center', cellWidth: 'wrap' },
                  } :
                    {
                      0: { halign: 'center', cellWidth: 'wrap' },
                      1: { halign: 'center', cellWidth: 'wrap', fontSize: this.tampilkanWaktu ? 8 : 10 },
                    };

        doc.autoTable({
          html: '#tabelJadwal',
          theme: 'grid',
          margin: {
            top: 20,
            right: 15,
            bottom: 15,
            left: 20
          },
          headStyles: {
            halign: 'center',
            cellPadding: 2,
            fillColor: '#184b89'
          },
          styles: {
            cellPadding: {
              top: 1,
              right: 2,
              bottom: 1,
              left: 2
            },
            valign: 'middle',
            lineWidth: 0.3,
            lineColor: '#666666'
          },
          columnStyles: columnStyles,
        });

        const namaFile = this.piket && this.hari && this.lokasi ? `${this.piket.nama}_${this.hari.nama}_${this.lokasi.nama}.pdf` :
          this.piket && this.hari ? `${this.piket.nama}_${this.hari.nama}.pdf` :
            this.piket && this.lokasi ? `${this.piket.nama}_${this.lokasi.nama}.pdf` :
              this.hari && this.lokasi ? `${this.hari.nama}_${this.lokasi.nama}.pdf` :
                this.piket ? `${this.piket.nama}.pdf` :
                  this.hari ? `${this.hari.nama}.pdf` :
                    `${this.lokasi.nama}.pdf`;

        doc.save(namaFile);
      } else {
        this.$swal({
          title: 'Perhatian',
          text: 'Jadwal kosong!',
          icon: 'warning',
          confirmButtonText: 'Baik'
        });
      }
    }
  },
}
</script>

<style></style>